// Same field-config + validate-function shape AccountInfo's location form uses
// (see AccountInfo/utils/formHelpers.js's validateField/validateLocation) —
// a field config array of {key, label, validators} plus a validate function
// that returns an errors map keyed by field.key, so this section reads like
// the same "form field" pattern used in the single- and multi-location
// account creation screens instead of a one-off ad hoc check.
import {validatePhoneNumber} from '../../../../utils/address-validation-util'

export const ONBOARDING_CONTACT_FIELDS = [
  {
    key: 'firstName',
    label: 'First Name',
    type: 'text',
    validators: ['required'],
  },
  {key: 'lastName', label: 'Last Name', type: 'text', validators: ['required']},
  {
    key: 'email',
    label: 'Email Address',
    type: 'email',
    validators: ['required', 'email'],
  },
  {
    key: 'mobile',
    label: 'Phone Number',
    type: 'tel',
    validators: ['required', 'phone'],
  },
]

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateOnboardingContact(values, countryCode = 'US') {
  const errors = {}

  ONBOARDING_CONTACT_FIELDS.forEach(field => {
    const value = values?.[field.key]
    const trimmedValue = typeof value === 'string' ? value.trim() : value

    if (field.validators.includes('required') && !trimmedValue) {
      errors[field.key] = `${field.label} is required`
      return
    }

    if (field.validators.includes('email') && trimmedValue) {
      if (!EMAIL_REGEX.test(trimmedValue)) {
        errors[field.key] = 'Invalid email address'
      }
    }

    if (field.validators.includes('phone') && trimmedValue) {
      if (!validatePhoneNumber(countryCode, trimmedValue)) {
        errors[field.key] = 'Invalid phone number'
      }
    }
  })

  return errors
}
